import { IconProps, SvgIcon } from 'modules/miles/shared/components/Icon/SvgIcon';
import React from 'react';

const MinusPath = <path d='M15.3334 7.38086V10.0475H0.666748V7.38086H15.3334Z' fill='currentColor' />;

export const Minus = (props: IconProps) => <SvgIcon path={MinusPath} viewBox={'0 0 16 17'} {...props} />;
